// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,  
  apiUrl: 'https://api-fotoblic.nsdevelop.pro/api',
  storageUrl: 'https://api-fotoblic.nsdevelop.pro/storage',
  photoBookUrl: 'https://foto-blic-urosevic.inbox.photo/app/photo-books',
  googleMapApi: '',
  app_version: '1.0',
  gtmContainerId: '',
  // STAGE WordPress
  wordpressApiUrl: 'https://fotoblic.nsdevelop.pro/wp-json',
  wordpressSiteUrl: 'https://fotoblic.nsdevelop.pro/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
